<template>
  <button class="button"
          :class="classes"
          :disabled="disabled"
          @mouseenter="mouseenterHandler"
          @mouseleave="mouseleaveHandler"
          @click="clickHandler">
    <icon v-if="icon"
          class="button__icon"
          :icon="icon"
          :colour="iconColour"
          :class="{ 'button__icon--right': iconAlignRight }"/>
    <slot/>
  </button>
</template>

<script>
import Icon from '../Icon'
import buttonComponentMixin from '../../mixins/buttonComponentMixin'

export default {
  name: 'Button',
  components: { Icon },
  mixins: [buttonComponentMixin],
  props: {
    icon: {
      type: String,
      required: false,
      default: null,
    },
    iconAlignRight: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    classes() {
      let classes = this.baseClasses

      if (this.icon) {
        classes = `${classes} button--with-icon`

        if (this.iconAlignRight) {
          classes = `${classes} button--with-icon-right-align`
        }
      }

      return classes
    },
  },
}
</script>
